import { ExternalLink } from "lucide-react";

const products = [
  { name: "GenieBot", tagline: "Your AI command center", description: "27+ tools, AI chat, chatbot builder, and the broadest AI toolkit for everyone.", href: "https://geniebot.pro", active: true },
  { name: "GenieBot", tagline: "AI for business", description: "Enterprise-grade AI tools for teams, automation, and business intelligence.", href: "https://geniebot.biz" },
  { name: "GenieBot", tagline: "AI for the global community", description: "Multi-language AI experiences built for a connected world.", href: "https://geniebot.world" },
  { name: "GenieBot", tagline: "The GenieBot community", description: "Exclusive access, community prompts, challenges, and rewards.", href: "https://geniebot.club" },
];

export const LandingGenieBotFamily = () => (
  <section id="ecosystem" className="py-20 px-4 bg-muted/20" aria-labelledby="family-heading">
    <div className="max-w-5xl mx-auto">
      <h2 id="family-heading" className="text-3xl md:text-4xl font-bold text-center mb-3">The GenieBot Family</h2>
      <p className="text-muted-foreground text-center mb-12 max-w-lg mx-auto">
        One brand, multiple specialized AI products — each built for a different need.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {products.map((p) =>
          p.active ? (
            <div
              key={p.href}
              className="group p-6 rounded-2xl border border-primary/40 bg-primary/5 shadow-[0_0_30px_hsl(var(--primary)/0.08)] transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-bold text-lg">{p.name}</h3>
                <span className="text-xs px-2 py-0.5 rounded-full bg-primary/20 text-primary font-medium">You are here</span>
              </div>
              <p className="text-primary text-sm font-medium mb-1">{p.tagline}</p>
              <p className="text-sm text-muted-foreground">{p.description}</p>
            </div>
          ) : (
            <a
              key={p.href}
              href={p.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group p-6 rounded-2xl border border-border bg-card hover:border-primary/20 transition-all duration-300 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none"
            >
              <div className="flex items-center justify-between mb-2">
                <h3 className="font-bold text-lg">{p.name}</h3>
                <ExternalLink className="h-4 w-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
              </div>
              <p className="text-primary text-sm font-medium mb-1">{p.tagline}</p>
              <p className="text-sm text-muted-foreground">{p.description}</p>
            </a>
          )
        )}
      </div>
    </div>
  </section>
);
